if (!customElements.get('form-validate')) {
  class FormValidation extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      if (!this.form) throw new Error('Form element does not exist');
    }

    toggleErrorMessage(input, field) {
      const errorMessageWrapper =
        field.querySelector('[data-message]');
      errorMessageWrapper.classList.toggle(
        'hidden',
        input.validity.valid
      );
      errorMessageWrapper.parentElement.classList.toggle(
        'has-error',
        !input.validity.valid
      );

      errorMessageWrapper.innerHTML =
        input.type === 'email'
          ? window.validationStrings.invalidEmail
          : input.validationMessage;
    }

    setFieldValidity(input) {
      input.setAttribute('aria-invalid', !input.validity.valid);
      const field = input.closest('[data-input-wrapper]');
      if (!field) return;
      field.classList.toggle('has-error', !input.validity.valid);
      this.toggleErrorMessage(input, field);
    }

    onSubmit(event) {
      if (!this.form.reportValidity()) event.preventDefault();
      this.form.submit();
    }

    setHandlers() {
      this.form.addEventListener('submit', this.onSubmit.bind(this));
      for (const input of this.form.elements) {
        if (input.hasAttribute('data-no-validate')) continue;

        ['input', 'blur', 'change', 'invalid'].forEach(eventName => {
          input.addEventListener(
            eventName,
            this.setInputHandler.bind(this)
          );
        });
      }
    }

    setInputHandler(event) {
      if (event.type === 'invalid') {
        event.preventDefault();
      }

      this.setFieldValidity(event.target);
    }

    connectedCallback() {
      this.setHandlers();
    }
  }

  customElements.define('form-validate', FormValidation);
}

document.addEventListener("DOMContentLoaded", () => {
  // Sadece kayıt sayfasında çalışsın
  if (!location.pathname.includes("/account/register")) return;

  // Register formunu bul
  const form = document.querySelector('form[action*="/account"]') || document.querySelector("form");
  if (!form) return;

  // NetGSM telefon inputunu yakala
  const phoneInput =
    form.querySelector('input[name*="phone" i]') ||
    form.querySelector('input[id*="phone" i]') ||
    form.querySelector('input[placeholder*="Telefon" i]');

  if (!phoneInput) return;

phoneInput.setAttribute("placeholder", "05xx xxx xx xx");


  // Telefon inputunun kapsayıcısını bul
  const phoneWrapper =
    phoneInput.closest(".form-row") ||
    phoneInput.closest(".field") ||
    phoneInput.parentElement;

  if (!phoneWrapper) return;

  // Hesap Oluştur butonunu bul
  const submitBtn = form.querySelector('button[type="submit"], input[type="submit"]');
  if (!submitBtn) return;

  const submitRow = submitBtn.closest(".form-row") || submitBtn.parentElement;

  // Telefonu submit butonunun ÜSTÜNE taşı
  submitRow.parentElement.insertBefore(phoneWrapper, submitRow);

  // CSS için class ekle
  phoneWrapper.classList.add("netgsm-phone-row");
  phoneInput.classList.add("netgsm-phone-input");

  // Mobil klavye vs.
  phoneInput.setAttribute("autocomplete", "tel");
  phoneInput.setAttribute("inputmode", "tel");
});


document.addEventListener("DOMContentLoaded", () => {
  if (!location.pathname.includes("/account/register")) return;

  const tryInit = () => {
    const form =
      document.querySelector('form[action*="/account"]') ||
      document.querySelector(".form-customer--register form") ||
      document.querySelector("form");
    if (!form) return false;

    // NetGSM telefon inputunu yakala
    const phoneInput =
      form.querySelector(".netgsm-phone-input") ||
      form.querySelector('input[name*="phone" i]') ||
      form.querySelector('input[id*="phone" i]') ||
      form.querySelector('input[placeholder*="telefon" i]');

    if (!phoneInput) return false;

    // Wrapper bul / yoksa oluştur
    let phoneWrapper =
      phoneInput.closest(".form-row") ||
      phoneInput.closest(".field") ||
      phoneInput.parentElement;

    if (!phoneWrapper) return false;

    // Daha önce işlem yaptıysak tekrar yapma
    if (!phoneWrapper.classList.contains("netgsm-phone-row")) {
      phoneWrapper.classList.add("netgsm-phone-row");
    }
    phoneInput.classList.add("netgsm-phone-input");

    // Placeholder değiştir
    phoneInput.setAttribute("placeholder", "05 ile başlayan telefon numaranızı girin");
    phoneInput.setAttribute("autocomplete", "tel");
    phoneInput.setAttribute("inputmode", "tel");

    // Submit butonunu bul ve telefon alanını üstüne al
    const submitBtn = form.querySelector('button[type="submit"], input[type="submit"]');
    if (submitBtn) {
      const submitRow = submitBtn.closest(".form-row") || submitBtn.parentElement;
      if (submitRow && submitRow.parentElement) {
        // Wrapper submitin ALTINDA kaldıysa, ÜSTÜNE taşı
        if (submitRow.parentElement.contains(phoneWrapper)) {
          submitRow.parentElement.insertBefore(phoneWrapper, submitRow);
        }
      }
    }

    // Diğer label classını kopyala (Ad*, Soyad* gibi)
    const existingLabel = form.querySelector("label");
    const labelClass = existingLabel ? existingLabel.className : "";

    // Bizim label zaten ekliyse tekrar ekleme
    if (!phoneWrapper.querySelector(".netgsm-custom-label")) {
      const newLabel = document.createElement("label");
      if (labelClass) newLabel.className = labelClass;
      newLabel.classList.add("netgsm-custom-label");
      newLabel.setAttribute("for", phoneInput.id || "");
      newLabel.textContent = "Telefon*";
      phoneWrapper.insertBefore(newLabel, phoneInput);
    }

    return true;
  };

  // NetGSM input bazen geç geldiği için birkaç kez dene
  let tries = 0;
  const timer = setInterval(() => {
    tries += 1;
    if (tryInit() || tries > 20) clearInterval(timer); // ~10 sn
  }, 500);
});
